import React from 'react';
import { connect } from 'react-redux';

import { getList } from 'src/reducers/common/listReducer';
import { REDUCER_NAME, deleteUnitPrice, getUnitPriceListErrors } from 'src/reducers/clients/unitPrices';
import { ErrorsSection } from 'src/components';

import { LinkBtn } from 'src/buttons';
import { CLIENT_UNIT_PRICE_NEW } from 'src/constants/EndpointUrls';
import { concatParamsToUrl } from 'src/utils/Http';
import { AddFile } from 'jbc-front/components/icons';
import ClientUnitPriceTableRow from '../components/ClientUnitPriceTableRow';
import styles from './ClientUnitPriceTable.scss';
import { useTranslation } from 'react-i18next';

const newUnitPriceUrl = payrollRulesGroupId => concatParamsToUrl(CLIENT_UNIT_PRICE_NEW, { payrollRulesGroupId });

const ClientUnitPriceTable = ({ payrollRulesGroupId, clientUnitPrices, onDelete, errors }) => {
  const { t } = useTranslation();
  return (
    <div>
      <div>
        <ErrorsSection errors={errors} />
      </div>
      <div className={styles.create}>
        <LinkBtn text={t('components.AllowanceDeductionForm.create_new')} link={newUnitPriceUrl(payrollRulesGroupId)} icon={<AddFile size={28} />} />
      </div>
      <div className="l-overflow-scroll">
        <table className="m-table-list">
          <thead>
            <tr>
              <th>{t('features.ClientUnitPrices.containers.ClientUnitPriceForm.Unit_price_name')}</th>
              <th className={styles.action} />
            </tr>
          </thead>
          <tbody>
            {clientUnitPrices.map(clientUnitPrice => (
              <ClientUnitPriceTableRow
                key={clientUnitPrice.id}
                {...clientUnitPrice}
                payrollRulesGroupId={payrollRulesGroupId}
                onDelete={onDelete}
              />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  clientUnitPrices: getList(REDUCER_NAME, state),
  errors: getUnitPriceListErrors(state)
});

const mapDispatchToProps = dispatch => ({
  onDelete: (payrollRulesGroupId, unitPriceId) => {
    dispatch(deleteUnitPrice(payrollRulesGroupId, unitPriceId));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(ClientUnitPriceTable);
